// extracted by mini-css-extract-plugin
module.exports = {"container":"Y","copy":"Z","field":"_","error":"aa","disabled":"ba","termsContainer":"ca","termsHeading":"da","termsCopy":"ea","submit":"fa","srOnly":"ga"};